import ProductsOverview from "@/pages/predictiveLeads/product/ProductsOverview";

import { useGetOrgaInfo } from "@/hooks/api/organisation/useGetOrgaInfo";
import PredictiveLeadsHeader from "@/components/organisms/predictive/PredictiveLeadsHeader";
import PredictiveLeadsIntro from "@/components/organisms/predictive/PredictiveLeadsIntro";

const PredictivePage = () => {
  const { data: organisation } = useGetOrgaInfo();

  if (!organisation?.has_ai_product) {
    return (
      <div className={"h-screen w-full overflow-y-auto px-6"}>
        <PredictiveLeadsHeader />
        <div className={"mx-auto max-w-2xl"}>
          <PredictiveLeadsIntro />
        </div>
      </div>
    );
  }

  return <ProductsOverview />;
};

export default PredictivePage;
